import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GetData from "../../services/getData";
import { Col, Container, Row } from "react-bootstrap";
import TitleWithIcon from "../../components/layout/pageTitle/PageTitle";
import clinicIcon from "../../media/clinics.png";
import BlockTitle from "../../components/layout/blockTitle/BlockTitle";
import "./contacts.css";

function ContactsProfile() {
  const { t } = useTranslation("contacts");
  const [clinic, setClinic] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [citiesMap, setCitiesMap] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    composition: "",
    price: "",
  });

  const { id } = useParams();
  const id_contact = Number(id);

  const loadingClinic = async (id_contact) => {
    setLoading(true);
    setError(null);
    try {
      const data = await GetData({
        module: "contacts",
        block: "info",
        id_contact,
      });

      let contactData = data.result || {};

      if (Array.isArray(contactData) && contactData.length > 0) {
        contactData = contactData[0];
      }

      if (typeof contactData !== "object" || contactData === null) {
        contactData = {};
      }

      setClinic(contactData);
      setCitiesMap(data.cities_map || {});
    } catch (err) {
      console.error("Ошибка загрузки услуги:", err);
      setError(err.message || t("profile.errors.loadFailed"));
    } finally {
      setLoading(false);
    }
  };

  // Загружаем услугу при изменении id
  useEffect(() => {
    if (id_contact) {
      loadingClinic(id_contact);
    } else {
      setClinic({});
      setLoading(false);
    }
  }, [id_contact]);

  useEffect(() => {
    setFormData({
      name: clinic.name || "",
      phone: clinic.phone || "",
      email: clinic.email || "",
      address: clinic.address || "",
      time: clinic.time || "",
      description: clinic.description || "",
      region: clinic.region || "",
      doctors_clinic: clinic.doctors_clinic || [],
    });
  }, [clinic]);


  useEffect(()=>{
    if (clinic?.name) {
      document.title = clinic.name;
    };
  }, [clinic])
  

  if (loading) {
    return (
      <Container fluid="md" className="mt-4">
        {t("state.loading", { ns: "common" })}
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid="md" className="mt-4">
        {t("error", { ns: "common", message: error })}
      </Container>
    );
  }

  const handleSave = async () => {
    try {
      const updatedData = {
        name: formData.name,
        phone: formData.phone,
        email: formData.email,
        address: formData.address,
        time: formData.time,
        description: formData.description,
        region: formData.region,
      };

      // Отправка на сервер
      await GetData({
        module: "contacts",
        block: "info",
        id_contact: id_contact,
        action: "change",
        data: updatedData,
      });

      // Перезагружаем данные клиники с сервера, чтобы получить корректное название региона
      await loadingClinic(id_contact);
      setIsEditing(false);
    } catch (err) {
      console.error("Ошибка сохранения:", err);
      alert(t("profile.errors.saveFailed"));
    }
  };

  const handleCancel = () => {
    setFormData({
      name: clinic.name || "",
      phone: clinic.phone || "",
      email: clinic.email || "",
      address: clinic.address || "",
      time: clinic.time || "",
      description: clinic.description || "",
      region: clinic.region || "",
    });
    setIsEditing(false);
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  console.log("Form_data:", formData);

  return (
    <Container fluid="md">
      <Row>
        <Col>
          {" "}
          <div className="patient-page">
            <TitleWithIcon
              icon={clinicIcon}
              title={formData.name || t("untitled", { ns: "common" })}
              showStatus={false}
              status={""}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="tab-content block page-block">
            <Row>
              <Col>
                <BlockTitle
                  title=""
                  buttons={
                    isEditing
                      ? [
                          {
                            label: t("actions.save", { ns: "common" }),
                            onClick: handleSave,
                            type: "normal",
                          },
                          {
                            label: t("actions.cancel", { ns: "common" }),
                            onClick: handleCancel,
                            type: "light",
                          },
                        ]
                      : [
                          {
                            label: t("actions.edit", { ns: "common" }),
                            onClick: handleEdit,
                            type: "light icon",
                          },
                        ]
                  }
                />
              </Col>
            </Row>
            <div className="service-container mt-4">
              <Row>
                <Col md={12}>
                  {/* Название */}
                  <div className="clinic-content">
                    {isEditing ? (
                      <>
                        {" "}
                        <div>
                          {" "}
                          <div className="form-label">{t("fields.name")}</div>
                          <input
                            type="text"
                            className="form-control mb-2"
                            value={formData.name}
                            onChange={(e) =>
                              handleChange("name", e.target.value)
                            }
                          />
                        </div>
                        <div>
                          <div className="form-label">{t("fields.city")}</div>
                          <select
                            className="form-control mb-2"
                            value={formData.region}
                            onChange={(e) =>
                              handleChange("region", e.target.value)
                            }
                          >
                            <option value="">{t("modal.selectCity")}</option>
                            {Object.entries(citiesMap).map(([cityName, cityId]) => (
                              <option key={cityId} value={cityId}>
                                {cityName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div>
                          {" "}
                          <div className="form-label">{t("fields.address")}</div>
                          <input
                            type="text"
                            className="form-control mb-2"
                            value={formData.address}
                            onChange={(e) =>
                              handleChange("address", e.target.value)
                            }
                          />
                        </div>
                        <div>
                          <div className="form-label">{t("fields.phone")}</div>
                          <input
                            type="text"
                            className="form-control mb-2"
                            value={formData.phone}
                            onChange={(e) =>
                              handleChange("phone", e.target.value)
                            }
                          />
                        </div>
                        <div>
                          <div className="form-label">{t("fields.time")}</div>
                          <input
                            type="text"
                            className="form-control mb-2"
                            value={formData.time}
                            onChange={(e) =>
                              handleChange("time", e.target.value)
                            }
                          />
                        </div>
                        <div>
                          <div className="form-label">
                            {t("fields.description")}
                          </div>
                          <input
                            type="text"
                            className="form-control mb-2"
                            value={
                              formData.description ? formData.description : "—"
                            }
                            onChange={(e) =>
                              handleChange("description", e.target.value)
                            }
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="title-clinic">
                          <div>{formData.name ? formData.name : "—"}</div>
                          <div className="city-clinic">
                            {formData.region ? formData.region : "—"}
                          </div>
                        </div>
                        <div className="address-clinic">
                          <div className="form-label">{t("fields.address")}</div>
                          <div>{formData.address ? formData.address : "—"}</div>
                        </div>
                        <div className="phone-clinic">
                          <div className="form-label">{t("fields.phone")}</div>
                          <div>{formData.phone ? formData.phone : "—"}</div>
                        </div>
                        <div className="work_time-clinic">
                          <div className="form-label">{t("fields.time")}</div>
                          <div>{formData.time ? formData.time : "—"}</div>
                        </div>
                        <div className="description-clinic">
                          <div className="form-label">
                            {t("fields.description")}
                          </div>
                          <div>
                            {formData.description ? formData.description : "—"}
                          </div>
                        </div>
                        <div className="doctors-clinic">
                          <div className="form-label">{t("profile.doctors")}</div>

                          {formData.doctors_clinic &&
                          formData.doctors_clinic.length > 0 ? (
                            <div className="doctors-clinic-table">
                              {formData.doctors_clinic.map((doctor) => (
                                <Link
                                  key={doctor.id}
                                  to={`/staff/${doctor?.id}/`}
                                  className="link-doctor">
                                  <div className="link-doctor-block">
                                    {doctor?.name}
                                  </div>
                                </Link>
                              ))}
                            </div>
                          ) : (
                            "—"
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default ContactsProfile;
